module.exports = __webpack_public_path__ + "assets/422f55b27ebb166c0fe656685651384f.mp3";